import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import * as reportsActions from "../../actions/reports";

export function useReportsStore() {
  const dispatch = useDispatch();
  const _reports = useSelector((store) => store.reports);

  const fetchDashboardStats = useCallback(
    async () => await dispatch(reportsActions.fetchDashboardStats()),
    [dispatch]
  );

  const fetchEventsStats = useCallback(
    async (params) => await dispatch(reportsActions.fetchEventsStats(params)),
    [dispatch]
  );

  const fetchEventsTimeSeriesStats = useCallback(
    async (from, to) =>
      await dispatch(reportsActions.fetchEventsTimeSeriesStats(from, to)),
    [dispatch]
  );

  const fetchEventSeriesStats = useCallback(
    async (from, to, eventUuid) =>
      await dispatch(reportsActions.fetchEventSeriesStats(from, to, eventUuid)),
    [dispatch]
  );

  const fetchPlanUsageStats = useCallback(
    async () => await dispatch(reportsActions.fetchPlanUsageStats()),
    [dispatch]
  );

  return {
    reports: _reports,
    fetchDashboardStats,
    fetchEventsStats,
    fetchEventsTimeSeriesStats,
    fetchEventSeriesStats,
    fetchPlanUsageStats,
  };
}
